import 'react-toastify/dist/ReactToastify.css';

import BG from './res/BG.jpg';
import nftVid from './res/nftComp.mp4';

import './App.css';

function NoWallet() {

	return (
		<div className="App">
			<img src={BG} className="backgroundImage" alt="wallpaper" />
			<header className="App-header">
				<div>
					<div className='nftContent'>
						<video className='nftVid' playsInline controls>
							<source src={nftVid} type='video/mp4' />
						</video>
						<div className='darkerCard'>
							<div className='nftDetails'>
								<div className='nftTitle'><b>Steven Vinyl</b> - <i>8-bit Madness</i></div>
								<div className='nftDesc'>8Bit Madness is a track inspired by the game Snafu. One of my favorite riffs modified and adapted in a modern, trippy and playful style, but still staying true to that old 8bit vibe. <br/><br/>Owner gets full rights of the track for world wide usage. <br/><br/>Released in partnership with Potluck Labs and the Jukebox Collective in 2022.</div>
								<div className='informations'>
									<span className='metamask'>Please Install Metamask</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
		</div>
	);
}

export default NoWallet;
